import { useEffect, type RefObject } from "react";

/**
 * Closes an openable when a pointer hits outside `containerRef`.
 * Does not mount a full-viewport capturing layer — underlying UI keeps
 * receiving the click (sidebar, Save, other Header icons).
 */
export function useCloseOpenableOnOutsidePointer(
	isOpen: boolean,
	close: () => void,
	containerRef: RefObject<HTMLElement | null>,
): void {
	useEffect(() => {
		if (!isOpen) {
			return undefined;
		}
		const onPointerDown = (event: PointerEvent): void => {
			const root = containerRef.current;
			const target = event.target;
			if (!root || !(target instanceof Node)) {
				return;
			}
			if (root.contains(target)) {
				return;
			}
			close();
		};
		document.addEventListener("pointerdown", onPointerDown, true);
		return (): void => {
			document.removeEventListener("pointerdown", onPointerDown, true);
		};
	}, [close, containerRef, isOpen]);
}
